import {Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {SessionStorageService} from './session-storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EtapaAtual, Proposta } from '../models/coleta';
import { ResponseBody } from '../models/response-body.model';

@Injectable({
  providedIn: 'root'
})
export class PropostaService extends BaseApiService {

  private readonly ENDPOINT_VALIDACAO = '/cliente/validacao'
  private readonly ENDPOINT_ENVIAR_CAPTACAO = '/captacoes'
  private readonly ENDPOINT_INICIO = '/inicio'
  private readonly ENDPOINT_ETAPA_ANTERIOR = '/etapas/id_etapa/anterior'

  constructor(private httpClient: HttpClient, private localStorageService: SessionStorageService) {
    super('whitelabel/propostas', localStorageService);
  }

  save(body: any): Promise<any> {
    return this.httpClient
      .post<any>(this.baseUrl, body)
      .toPromise();
  }

  
  validarCliente(body: any): Promise<any> {
    return this.httpClient
      .post<any>(`${this.baseUrl}${this.ENDPOINT_VALIDACAO}`, body)
      .toPromise();
  }

  buscar(id: any): Observable<Proposta> {
    return this.httpClient.get<ResponseBody<Proposta>>(`${this.baseUrl}/${id}`)
    .pipe(map(responseBody => responseBody.data));
  }

  buscarEtapaAnterior(id: any): Observable<EtapaAtual> {
    return this.httpClient.get<ResponseBody<EtapaAtual>>(`${this.baseUrl}${this.ENDPOINT_ETAPA_ANTERIOR.replace("id_etapa", id)}`)
    .pipe(map(responseBody => responseBody.data));
  }

  enviarCaptacao(body: any): Promise<Proposta> {
    return this.httpClient
      .post<any>(`${this.baseUrl}${this.ENDPOINT_ENVIAR_CAPTACAO}`, body)
      .pipe(map(responseBody => responseBody.data.proposta))
      .toPromise();
  }

  inicio(body: any, token: any, captchaProvider: string): Promise<Proposta> {
    let params = this.validateSocioParam();

    const headers = new HttpHeaders({
      'x-tenant-code': `${token}`,
      'x-recaptcha-provider': `${captchaProvider}`
    });

    return this.httpClient
      .post<any>(`${this.baseUrl}${this.ENDPOINT_INICIO}`, body, { headers: headers, params: params })
      .pipe(map(responseBody => responseBody.data))
      .toPromise();
  }

  private validateSocioParam() {
    let socioParam = this.localStorageService.getEnvConfig().autofillSocio;
    socioParam = socioParam == undefined ? false : socioParam;

    let params = new HttpParams();
    params = params.append('paramSocioPJ', socioParam);
    return params;
  }
}
